import { render, staticRenderFns } from "./Erp6SaleBaseCustomerInfo.vue?vue&type=template&id=1b4987f6&scoped=true&"
import script from "./Erp6SaleBaseCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseCustomerInfo.vue?vue&type=style&index=0&id=1b4987f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4987f6",
  null
  
)

export default component.exports